<div style="display: flex; flex-direction: column; flex: 1; max-height: 100vh">
    <!-- Header -->
    <div>
        <div style="display: flex; flex-direction: row; height: 50px">
            <div class="mat-dialog-title" style="display: flex; flex-direction: column; flex: 1;" translate>Settings</div>
            <div style="display: flex; flex-direction: column; flex: .2; align-items: flex-end; margin-right: 10px">
                <button mat-stroked-button class="help-button" (click)="helpClick()"><span translate>Help</span></button>
            </div>
        </div>
        <div class="card-list-item-header">
            <div style="display: flex; flex-direction: row; flex: 1">
                <div style="display: flex; flex-direction: column; flex: 1.5">
                    <span></span>
                </div>
                <div style="display: flex; flex-direction: column; flex: 1; align-items: center">
                    <span translate>Off</span>
                </div>
                <div style="display: flex; flex-direction: column; flex: 1">
                    <span translate>Summary</span>
                </div>
                <div style="display: flex; flex-direction: column; flex: 1">
                    <span translate>Detailed</span>
                </div>
            </div>
        </div>
    </div>
    <!-- Content -->
    <div style="flex-grow: 3; overflow: auto">
        <div style="display: flex; flex-direction: row;">
            <div cdkDropList class="card-list" (cdkDropListDropped)="drop($event)">
                <div class="card-list-item" *ngFor="let card of cards" cdkDrag>
                    <div style="display: flex; flex-direction: row; flex: 1">
                        <div style="display: flex; flex-direction: column; flex: .2;">
                            <img alt="Re-Order" title="Re-Order" src="./assets/images/grip.png" style="width: 10px">
                        </div>
                        <div *ngIf="card.title != 'Column Break'" style="display: flex; flex-direction: column; flex: 2">
                            {{card.title | translate}}
                        </div>
                        <div *ngIf="card.title == 'Column Break'"
                             style="display: flex; flex-direction: column;flex: 1;position: relative;left: -7%;">
                            <h5><span>{{card.title | translate}}</span></h5>
                        </div>
                        <div *ngIf="card.title != 'Column Break'" style="display: flex; flex-direction: column; flex: 1">
                            <mat-radio-group *ngIf="checkColumnName(card)">
                                <mat-radio-button [checked]="card.display == 'Off'" value="Off"
                                                  (change)="selectionChanged(card, $event)"></mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div *ngIf="card.title != 'Column Break'" style="display: flex; flex-direction: column; flex: 1">
                            <mat-radio-group *ngIf="card.hasSummaryCard">
                                <mat-radio-button [checked]="card.display == 'Summary'" value="Summary"
                                                  (change)="selectionChanged(card, $event)"></mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div *ngIf="card.title != 'Column Break'" style="display: flex; flex-direction: column; flex: 1">
                            <mat-radio-group *ngIf="showDetailedOption(card)">
                                <mat-radio-button [checked]="card.display == 'Detail'" value="Detail"
                                                  (change)="selectionChanged(card, $event)"></mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Footer -->
    <div style="flex-grow: 1; max-height: 70px">
        <div style="background-color: #e8eaf6; height: 70px; display: flex; flex-direction: row; align-items: center; justify-content: flex-end;">
            <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
            <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </div>
</div>
